import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators, FormsModule } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { QuestionService } from 'src/app/manage/questionanswer/service/question.service';
import { UserContestService } from 'src/app/services/usercontest.service';
@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss'],
  providers: [],
})
export class QuizComponent implements OnInit {
  items: MenuItem[];
  public options;
  public loading: boolean;
  public errorMessage: string;
  public totalRecords = 0;
  public quizList: any[] = [];
  public checkedBoxes: any[] = [];
  public attemptedQuestions: any[] = [];
  public resultList: any[] = [];
  public currentIndex: number = 0;
  public selectedOption: any = null;
  public currentQuestion;
  public answerString;
  public showSubmitButton: boolean = false;
  public showResult: boolean = false;
  public totalMarks: number = 0;
  public questionMarksTotal: number = 0;
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  @ViewChild('prevButton') prevButton: ElementRef;
  @ViewChild('nextButton') nextButton: ElementRef;
  constructor(private questionService: QuestionService, private userContestService: UserContestService) { }
  ngOnInit(): void {
    this.getQuiz();
    this.items = [
      { routerLink: "/", label: "Home" },
      { label: "Club Leagues" }
    ]
  }
  getQuiz() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.questionService.getQuestionAnswerList(query).subscribe(
      data => {
        this.loading = false;
        this.quizList = data.data.items;
        this.quizList.forEach(element => {
          let optionsArr = [
            { label: element.option1 },
            { label: element.option2 },
            { label: element.option3 },
            { label: element.option4 },
          ]
          delete element['created_at'];
          element['options'] = optionsArr;
        })
        this.totalRecords = data.data.totalCount;
        this.shuffleQuizList();
        this.currentQuestion = this.quizList[this.currentIndex];
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  saveAnswer() {
  }
  private shuffleQuizList(): void {
    let currentIndex = this.quizList.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = this.quizList[currentIndex];
      this.quizList[currentIndex] = this.quizList[randomIndex];
      this.quizList[randomIndex] = temporaryValue;
    }
  }
  prev() {
    if (this.currentIndex == 0) return;
    this.showSubmitButton = false;

    if (this.nextButton != undefined) {
      if (this.nextButton.nativeElement.hasAttribute('disabled')) {
        this.nextButton.nativeElement.removeAttribute('disabled');
      }
    }
    if (this.currentIndex == 1) {
      this.prevButton.nativeElement.setAttribute('disabled', 'true');
    }
    this.currentQuestion = this.quizList[--this.currentIndex];
    this.clear();


    let index = this.findIndexById(this.currentQuestion._id, this.attemptedQuestions);

    if (index != -1) {
      this.attemptedQuestions.splice(index, 1);
    }
    // let query = "?filterByDisable=false&filterByQuestionId=" + this.currentQuestion._id;
    // this.userContestService.getUserContestList(query).subscribe(
    //   data => {
    //     console.log('get previous data', data.data.items[0]);
    //     this.selectedOption = data.data.items[0].answer;
    //   },
    //   err => {

    //   }
    // );
    this.selectedOption = null;
  }
  async next() {

    this.attemptedQuestions.push({ id: this.currentQuestion._id, answer: this.selectedOption, });

    if (this.currentIndex >= this.quizList.length - 1) return;
    if (this.prevButton.nativeElement.hasAttribute('disabled')) {
      this.prevButton.nativeElement.removeAttribute('disabled');
    }
    if (this.currentIndex >= this.quizList.length - 2) {
      this.nextButton.nativeElement.setAttribute("disabled", "true");
      this.showSubmitButton = true;
    }
    let userContestData = {
      questionId: this.currentQuestion._id, answer: this.selectedOption,
    }
    this.userContestService.addUserContest(userContestData).subscribe(
      async data => { },
      err => { }
    );
    this.currentQuestion = this.quizList[++this.currentIndex];
    this.clear();
  }
  async submit() {
    await this.userContest();
  }
  async userContest() {
    let userContestData = {
      questionId: this.currentQuestion._id, answer: this.selectedOption,
    }
    this.userContestService.addUserContest(userContestData).subscribe(
      async data => {
        await this.getResult();
      },
      err => {
      }
    );
  }
  async getResult() {
    let query = 'filterByDisable=false';
    this.userContestService.getUserContestList(query).subscribe(
      data => {
        this.resultList = data.data.items;
        this.totalMarks = 0;
        this.resultList.forEach(element => {
          this.totalMarks = Number(element.score) + Number(this.totalMarks);

          this.questionMarksTotal = Number(element.questionanswerdata[0].score) + this.questionMarksTotal;
        });

        this.showResult = true;
      },
      err => {
        console.log(err);
      }
    );
  }
  findIndexById(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  private clear(): void {
    this.answerString = "";
    this.checkedBoxes = [];
  }
}
